import React, {useState} from 'react'

import {
  Container, Modal, Button, Form
} from 'react-bootstrap';

import _ from 'lodash';
import cx from 'classnames';
import { IKImage } from "imagekitio-react";

import { MediaLibraryModal } from 'components/MediaLibrary';

import StoryboardContext from "components/Storyboard/context";

import styles from './componentStyles.module.scss';

export const ThumbnailControl = ({ value, onChange, className}) => {
  const [library, setLibrary] = useState(false);
  const storyboardContext = React.useContext(StoryboardContext);

  const iconUrl = _.get(value, 'url') || _.get(value, 'key');

  const handleShowMediaLibrary = () => {
    setLibrary(true);
  }

  const handleImageChange = (medias) => {
    const media = medias[0];
    onChange(media);
    setLibrary(false);
  }
  return (
    <>
      <div className={cx(styles.thumbnailControl, className)}>
        {value && (
          <IKImage
            className={styles.icon}
            path={iconUrl}
          />)
        }
        {
          !value && (<img src={'/images/storyboard.png'} className={styles.icon} />)
        }
        <div className={styles.overlay} onClick={handleShowMediaLibrary}>
          <Button variant="primary">
            Change Thumbnail
          </Button>
        </div>
      </div>
      <MediaLibraryModal
        show={library}
        mediaTypes={['image']}
        storyboard={storyboardContext}
        multiple={false}
        onSelect={handleImageChange}
        onClose={() => {
          setLibrary(false);
        }}
      />
    </>
  )
}